import React from 'react';
import { ComplexRoute } from 'router/components/Routes/Routes';
import SignupChangePassword from './pages/SignupChangePassword';
import { Navigate } from 'react-router-dom';
import AuthPhoneNumber from './pages/AuthPhoneNumber';
import AuthVerification from './pages/AuthVerification';

export default [
  {
    path: 'change-password',
    element: SignupChangePassword,
  },
  {
    path: 'add-phone',
    element: AuthPhoneNumber,
  },
  {
    path: 'verify-phone',
    element: AuthVerification,
  },
  {
    index: true,
    element: <Navigate to="change-password" />,
  },
] as Array<ComplexRoute>;
